module.exports = __webpack_public_path__ + "static/img/login-top-bg.7967fd85.jpg";